import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <nav className="main-navigation">
      <div className="nav-container">
        <Link to="/" className="logo">
          <h1>IdeaPetal Games</h1>
        </Link>
        <ul className="nav-links">
          <li>
            <Link to="/" className={isActive('/')}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/games" className={isActive('/games')}>
              Web Games
            </Link>
          </li>
          <li>
            <Link to="/mobile-games" className={isActive('/mobile-games')}>
              Mobile Games
            </Link>
          </li>
          <li>
            <Link to="/about" className={isActive('/about')}>
              About Us
            </Link>
          </li>
          <li className="legal-dropdown">
            <span className="dropdown-trigger">Legal</span>
            <ul className="dropdown-menu">
              <li>
                <Link to="/terms">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/mobile-games-terms">Mobile Games Terms</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/cookie-policy">Cookie Policy</Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/contact" className={isActive('/contact')}>
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;
